var productMediaModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: function () {
          document
            .querySelectorAll(".sr-product-model-item")
            .forEach((model) => {
              let model3D = model.querySelector("model-viewer");
              model.modelViewerUI = new Shopify.ModelViewerUI(model3D);
              model3D.addEventListener(
                "shopify_model_viewer_ui_toggle_play",
                function (evt) {
                  model
                    .querySelectorAll(".close-product-model")
                    .forEach((el) => {
                      el.classList.remove("hidden");
                    });
                  let productdataMedia = model.closest("[data-slideshow]");
                  if (productdataMedia) {
                    let productMediaSlider = Flickity.data(productdataMedia);
                    if (productMediaSlider) {
                      productMediaSlider.options.draggable = false;
                      productMediaSlider.updateDraggable();
                    }
                  }
                }.bind(this)
              );

              model3D.addEventListener(
                "shopify_model_viewer_ui_toggle_pause",
                function (evt) {
                  model
                    .querySelectorAll(".close-product-model")
                    .forEach((el) => {
                      el.classList.add("hidden");
                    });
                  let productdataMedia = model.closest("[data-slideshow]");
                  if (productdataMedia) {
                    let productMediaSlider = Flickity.data(productdataMedia);
                    if (productMediaSlider) {
                      productMediaSlider.options.draggable = true;
                      productMediaSlider.updateDraggable();
                    }
                  }
                }.bind(this)
              );

              model.querySelectorAll(".close-product-model").forEach((el) => {
                el.addEventListener(
                  "click",
                  function () {
                    if (model3D) {
                      model.modelViewerUI.pause();
                    }
                  }.bind(this)
                );
              });
            });
        },
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (!errors) {
      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", () =>
          this.setupShopifyXR()
        );
        return;
      }
      document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
        window.ShopifyXR.addModels(JSON.parse(model.textContent));
      });
      window.ShopifyXR.setupXRElements();
    }
  },
};

window.addEventListener("DOMContentLoaded", () => {
  let productModel = document.querySelectorAll('[id^="product3DModel-"]');
  if (productMediaModel && productModel.length > 0) {
    productMediaModel.loadShopifyXR();
  }

  /*let productTerms = document.querySelectorAll("[data-product-terms]");
    if (productTerms) {
        Array.from(productTerms).forEach(function(productTerm) {
            if(productTerm.checked){
            console.log('checked');
              productTerm.closest("[data-product-wrapper]").querySelector('[name="add"]').removeAttribute("disabled");
            }else {
              console.log('not checked');
              productTerm.closest("[data-product-wrapper]").querySelector('[name="add"]').setAttribute("disabled", true)   
            }
        });
    }*/
});

console.log("called>>>>>>product.js>>>>");

// ////////////////////////////////////
// VIEW CONTENT FB PIXEL
// ///////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  if (window.productData) {
    console.log("called>>>>>>ViewContent>>>>");
    fbq("track", "ViewContent", {
      content_name: window.productData.title,
      content_ids: [window.productData.id],
      content_type: window.productData.content_type,
      value: window.productData.price,
      currency: window.productData.currency,
    });

    if (typeof gtag !== "undefined") {
      gtag("event", "ProductView", {
        send_to: "AW-10849848868/VsURCLHCzpoDEKSczrUo",
        value: window.productData.price,
        title: window.productData.title,
        currency: "INR",
        event_label: "Product View",
      });

      // OLD
      gtag("event", "ProductView", {
        send_to: "AW-17009293754/F4P7CN-1irkaELrz1K4_",
        value: window.productData.price,
        title: window.productData.title,
        currency: "INR",
        event_label: "Product View",
      });
      console.log("PRODUCT VIEW - GOOGLE ADS TRIGGERED : ", value, title);
    } else {
      console.log("PRODUCT VIEW - GOOGLE ADS ERROR ");
    }
  }
});
